// https://cloud.google.com/storage/docs/performing-resumable-uploads
// Create chunks in multiples of 256 KB (256 x 1024 bytes) in size
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var CHUNK_SIZE = 256 * 1024 * 4; // 1MB
var BUCKET_NAME = 'bug-reports.oui.dev';
function initializeResumableUpload(blob, fileName) {
    return _initializeResumableUpload.apply(this, arguments);
}
function _initializeResumableUpload() {
    _initializeResumableUpload = _async_to_generator(function(blob, fileName) {
        var mimeType, size, body, result, resultBody, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    mimeType = blob.type;
                    size = blob.size.toString();
                    body = JSON.stringify({
                        name: "resumable/".concat(fileName)
                    });
                    return [
                        4,
                        fetch("https://storage.googleapis.com/upload/storage/v1/b/".concat(BUCKET_NAME, "/o?uploadType=resumable"), {
                            method: 'POST',
                            body: body,
                            headers: {
                                'Content-Length': body.length.toString(),
                                'Content-Type': 'application/json; charset=UTF-8',
                                'X-Upload-Content-Type': mimeType,
                                'X-Upload-Content-Length': size
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if (!(result.status >= 400)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        result.text()
                    ];
                case 2:
                    resultBody = _state.sent();
                    error = new Error("initializeResumableUpload failed: (".concat(result.status, ") ").concat(resultBody));
                    error.status = result.status;
                    throw error;
                case 3:
                    return [
                        2,
                        result.headers.get('location')
                    ];
            }
        });
    });
    return _initializeResumableUpload.apply(this, arguments);
}
function getLastByteFromRange(range) {
    if (range) {
        return Number.parseInt(range.split('-')[1], 10);
    }
    return -1;
}
// node-fetch doesn't play nicely with blob.slice since it expects a node stream instead of
// whatwg stream, so we convert to a buffer which is handled better
function uploadResumableChunkFactory(useBuffer) {
    return /*#__PURE__*/ function() {
        var _uploadResumableChunk = _async_to_generator(function(sessionUri, blob, start) {
            var end, size, headers, result, _tmp, _tmp1, _tmp2, body, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        end = Math.min(start + CHUNK_SIZE, blob.size);
                        size = end - start;
                        headers = {
                            'Content-Length': size.toString(),
                            'Content-Range': "bytes ".concat(start, "-").concat(end - 1, "/").concat(blob.size)
                        };
                        _tmp = [
                            sessionUri
                        ];
                        _tmp1 = {
                            method: 'PUT',
                            headers: headers
                        };
                        if (!useBuffer) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            blob.slice(start, end).arrayBuffer()
                        ];
                    case 1:
                        _tmp2 = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp2 = blob.slice(start, end);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            fetch.apply(void 0, _tmp.concat([
                                (_tmp1.body = _tmp2, _tmp1)
                            ]))
                        ];
                    case 4:
                        result = _state.sent();
                        if (!(result.status >= 400)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            result.text()
                        ];
                    case 5:
                        body = _state.sent();
                        error = new Error("uploadResumableChunk failed: (".concat(result.status, ") ").concat(body));
                        error.status = result.status;
                        throw error;
                    case 6:
                        return [
                            2,
                            {
                                isComplete: [
                                    200,
                                    201
                                ].includes(result.status),
                                lastByte: getLastByteFromRange(result.headers.get('range'))
                            }
                        ];
                }
            });
        });
        function uploadResumableChunk(sessionUri, blob, start) {
            return _uploadResumableChunk.apply(this, arguments);
        }
        return uploadResumableChunk;
    }();
}
function checkResumableUpload(sessionUri) {
    return _checkResumableUpload.apply(this, arguments);
}
function _checkResumableUpload() {
    _checkResumableUpload = _async_to_generator(function(sessionUri) {
        var result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(sessionUri, {
                            method: 'PUT',
                            headers: {
                                'Content-Length': '0',
                                'Content-Range': 'bytes */*'
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        {
                            isComplete: [
                                200,
                                201
                            ].includes(result.status),
                            lastByte: getLastByteFromRange(result.headers.get('range'))
                        }
                    ];
            }
        });
    });
    return _checkResumableUpload.apply(this, arguments);
}
export var GcsResumableUploader = {
    checkResumableUpload: checkResumableUpload,
    uploadResumableChunk: uploadResumableChunkFactory(false),
    initializeResumableUpload: initializeResumableUpload
};
export var GcsNodeResumableUploader = {
    checkResumableUpload: checkResumableUpload,
    uploadResumableChunk: uploadResumableChunkFactory(true),
    initializeResumableUpload: initializeResumableUpload
};
